import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { listPrestations, createPrestation, updatePrestation } from "../services/api";
import Popup from "./Popup";
import "./SalarieForm.css";

const PrestationForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditing = Boolean(id);

  const [formData, setFormData] = useState({ name: "", prix_heure: "" });
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState({
    isOpen: false,
    title: "",
    content: null,
    type: "success",
  });
  const [error, setError] = useState("");

  useEffect(() => {
    if (isEditing) fetchPrestation();
    // eslint-disable-next-line
  }, [id, isEditing]);

  const fetchPrestation = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await listPrestations();
      console.log("Fetched prestations:", data); // Debug log
      
      if (!Array.isArray(data)) {
        throw new Error("Invalid data format received");
      }
      
      const prestation = data.find(p => p.id === parseInt(id));
      if (!prestation) {
        throw new Error("Prestation introuvable");
      }
      
      setFormData({ 
        name: prestation.name || "", 
        prix_heure: prestation.prix_heure || "" 
      });
    } catch (err) {
      console.error("Error fetching prestation:", err);
      setError(err.response?.data?.message || err.message || "Erreur lors du chargement des prestations");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    
    // Validate form data
    if (!formData.name.trim()) {
      setError("Le type de prestation est requis.");
      return;
    }
    
    if (!formData.prix_heure || parseFloat(formData.prix_heure) <= 0) {
      setError("Le prix par heure doit être supérieur à 0.");
      return;
    }
    
    setLoading(true);

    try {
      // Ensure proper data format
      const submitData = {
        name: formData.name.trim(),
        prix_heure: parseFloat(formData.prix_heure)
      };

      if (isEditing) {
        await updatePrestation(id, submitData);
      } else {
        await createPrestation(submitData);
      }
      setPopup({
        isOpen: true,
        title: isEditing ? "Prestation modifiée" : "Prestation ajoutée",
        content: (
          <div>
            <p>
              {isEditing
                ? "La prestation a été modifiée avec succès."
                : "La prestation a été ajoutée avec succès."}
            </p>
          </div>
        ),
        type: "success",
      });
    } catch (err) {
      console.error("Error submitting prestation:", err);
      setError(err.response?.data?.message || err.message || "Erreur lors de la sauvegarde.");
    } finally {
      setLoading(false);
    }
  };

  const closePopup = () => {
    setPopup({ ...popup, isOpen: false });
    navigate("/prestations");
  };

  return (
    <div className="salarie-form-modal" style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '20px',
      backgroundColor: '#f5f5f5'
    }}>
      <form className="salarie-form" onSubmit={handleSubmit} style={{
        maxWidth: '500px',
        width: '100%',
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        margin: 'auto'
      }}>
        <h2>{isEditing ? "Modifier Prestation" : "Ajouter une prestation"}</h2>
        <div className="form-group">
          <label className="form-label">Type de prestation *</label>
          <input
            type="text"
            name="name"
            className="form-input"
            value={formData.name}
            onChange={handleChange}
            placeholder="Type de prestation"
            autoComplete="off"
            required
            autoFocus
          />
        </div>
        <div className="form-group">
          <label className="form-label">Prix heure (€) *</label>
          <input
            type="number"
            name="prix_heure"
            className="form-input"
            value={formData.prix_heure}
            onChange={handleChange}
            placeholder="Prix par heure"
            min="0"
            step="0.01"
            autoComplete="off"
            required
          />
        </div>
        {error && (
          <div style={{ color: "#dc3545", marginBottom: 16, textAlign: "center" }}>
            {error}
          </div>
        )}
        <div className="form-actions">
          <button
            type="button"
            onClick={() => navigate("/prestations")}
            className="btn btn-secondary"
            disabled={loading}
          >
            
            Annuler
          </button>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Sauvegarde..." : isEditing ? "Modifier" : "Ajouter"}
          </button>
        </div>
      </form>
      <Popup
        isOpen={popup.isOpen}
        onClose={closePopup}
        title={popup.title}
        type={popup.type}
      >
        {popup.content}
      </Popup>
    </div>
  );
};


export default PrestationForm;
